import Snowflake from "../../../../contents/docs/cdp/sources/_snippets/source-snowflake.mdx";
import * as React from 'react';
export default {
  Snowflake,
  React
};